(function(algolia) {
    'use strict';
  
    const getAlgoliaResults = algolia.externals.getAlgoliaResults;
    const { config, translations, headerTemplate, collectionsTemplate } = algolia;
  
    algolia.collectionsPlugin = {
      getSources({ query,state }) {
        if(algolia.queryThreshold && query.length < algolia.queryThreshold) return[]
        return [
          {
            sourceId: 'collections',
            getItems() {
              return getAlgoliaResults({
                searchClient: algolia.searchClient,
                queries: [
                  {
                    indexName: config.index_prefix + 'collections',
                    query,
                    params: {
                      hitsPerPage: config.collections_autocomplete_hits_per_page,
                      clickAnalytics: config.analytics_enabled
                    },
                  },
                ],
              });
            },
            templates: {
              header({ html, state }) {
                const resource = translations.collections;
                return headerTemplate({ html, state }, resource);
              },
              item({ item, html, components }) {
                const itemLink = `/collections/${item.handle}`;
                return collectionsTemplate({ item, html, components }, itemLink);
              },
            },
          }
        ];
      },
    }
  })(window.algoliaShopify);